<div>
  <h3 class="page-title">{{pageTitle | translate}}</h3>
  <legend>{{'Create a new password using these guidelines' | translate}}:</legend>
  <ul>
    <li>{{passwordLengthText}}</li>
    <li>{{'Must not contain username.' | translate}}</li>
    <li>{{numberOfPasswordRememberedText}}</li>
    @if (!policy?.allowMoreThanThreeRepeatingCharacters) {
      <li>{{'Cannot be repeating strings as 0000 or zzzz' | translate }}</li>
    }
    <li>{{numberOfRulesToApplyText}}:</li>
    <ul>
      @if (policy?.requiresOneUpperCase) {
        <li>{{'Must contain at least one uppercase character' | translate}}</li>
      }
      @if (policy?.requiresOneLowerCase) {
        <li>{{'Must contain at least one lowercase character' | translate}}</li>
      }
      @if (policy?.requiresOneNumber) {
        <li>{{'Must contain at least one numeric character' | translate}}</li>
      }
      @if (policy?.requiresOneSpecialCharacter) {
        <li>{{'Must contain at least one special character' | translate}}</li>
      }
    </ul>
  </ul>

  <span class="flex-form"> {{'We also recommend that password construction be complex and not contain names, dictionary words, combinations of words, or words with substitutions of numbers for letters, e.g., s3curity.' | translate }}
  </span>
  <form (keydown.enter)="$event.preventDefault()" class="flex-form" (ngSubmit)="send()" [formGroup]="cpForm"
    novalidate>

    <mat-form-field>
      <mat-label>{{'Current Password' | translate}}</mat-label>
      <input formControlName="currentPassword" matInput id="currentPassword" type="password" [placeholder]="'Current Password' | translate">
      @if (cpForm.get('currentPassword').errors?.required) {
        <mat-error>
          {{ 'Current Password is required' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{'New Password' | translate }}</mat-label>
      <input formControlName="password" matInput id="password" [placeholder]="'New Password' | translate" type="password">
      @if (cpForm.get('password').errors?.required) {
        <mat-error>
          {{'New Password is required' | translate }}
        </mat-error>
      }
      @if (cpForm.get('password').errors?.minlength) {
        <mat-error>
          {{'New Password must be at least' | translate}} {{policy?.passwordLength}} {{'characters long' | translate}}.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{'Confirm New Password' | translate}}</mat-label>
      <input formControlName="password2" matInput id="password2" placeholder="{{'Confirm New Password' | translate}}" type="password"
        (keyup.enter)="send()">
      @if (cpForm.get('password2').errors?.required) {
        <mat-error>
          {{'Confirm New Password is required.' | translate}}
        </mat-error>
      }
      @if (cpForm.get('password').errors?.minlength) {
        <mat-error>
          {{'Confirm New Password' | translate}}  {{passwordLengthErrorText}}
        </mat-error>
      }
      @if (cpForm.get('password2').errors?.mustMatch) {
        <mat-error>
          {{'New Password and Confirm New Password must match' | translate}}
        </mat-error>
      }

    </mat-form-field>

  </form>
</div>

